
import { EventParticipation, EventType } from "@/models";
import { defineComponent } from "@vue/runtime-core";
import Card from "../ui/Card.vue";
import Btn from "../ui/Btn.vue";
import Timeline from "../ui/Timeline.vue";
import Timestamp from "../ui/Timestamp.vue";
import SkeletonCard from "../ui/SkeletonCard.vue";
import Avatar from "../ui/Avatar.vue";
export default defineComponent({
	name: "MicTalking",
	// mixins: [courseIdMixin, loadingMixin],
	props: {
		talking: {
			type: Boolean,
			required: true,
		},
	},
	watch: {},
	data() {
		return {};
	},
	methods: {},
	computed: {},
	components: {},
});
